export default __webpack_public_path__ + "static/video-presentation-ateliers-ensemble-au-micro-one-station-11f1aeb4372d4f67acf114ef436f8ab8.mp4";